// Utils
import { component } from 'picoapp';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';

import { repaint } from 'utils/node';

export default component((node) => {
  const classes = {
    active: 'product__lightbox--active',
  };

  let isActive = false;
  const closeButton = node.querySelector('[data-close]');
  const toggles = document.querySelectorAll('[data-lightbox-item]');
  const items = node.querySelectorAll('[data-item]');

  const open = (index = 0) => {
    disablePageScroll(node);
    isActive = true;
    node.hidden = false;
    repaint(node);
    node.classList.add(classes.active);

    node.scroll(0, items[index].offsetTop);
  };

  const close = () => {
    enablePageScroll(node);
    isActive = false;

    node.classList.remove(classes.active);
    node.addEventListener(
      'transitionend',
      () => {
        if (isActive === false) {
          node.hidden = true;
        }
      },
      { once: true },
    );
  };

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      close();
    }
  });

  closeButton.addEventListener('click', close);

  toggles.forEach((toggle, index) => {
    toggle.addEventListener('click', (event) => {
      if (
        !event.target.classList.contains('stl-label__link') &&
        !event.target.classList.contains('stl-label')
      ) {
        open(index);
      }
    });
  });
});
